<template>
  <div>
    <v-card-text class="text-center">
      <img
         v-if="currentNotification.shopId"
        :src="!currentNotification.shopImage? placeholder : domainHost + currentNotification.shopImage.replace('~','')"
        alt="notification image"
        width="300"
        height="200"
        style="min-height: 100%"
        class="rounded-tr-0"
      />
      <ul class=" list-unstyled p-0 m-0 d-flex justify-space-between pt-3">
        <li class="d-flex align-items-center">
          <img src="/media/svg/edit.svg" alt="edit" width="24" class="ml-1" />
          <strong class="text-white">{{
              !currentNotification.shopName
              ? "بلا مشترك"
              : currentNotification.shopName
          }}</strong>
        </li>
        <!-- <li class="d-flex align-items-center">
          <img
            src="/media/svg/document.svg"
            alt="document"
            width="28"
            class="ml-1"
          />
          <strong class="text-white">{{ currentNotification.title }}</strong>
        </li> -->
        <li class="d-flex align-items-center">
          <img
            src="/media/svg/calendar.svg"
            alt="calendar"
            width="22"
            class="ml-1"
          />
          <strong class="text-white">{{ new Date(currentNotification.createdAt).toISOString().substr(0, 10) }}</strong>
        </li>
      </ul>
    </v-card-text>
    <div class="text-right">
 <label class="">عنوان الإشعار:</label> 
    <v-card-text class="white rounded-xl rounded-tr-0 text-right mb-3">
      <p class="lead m-0 text-justify" style="line-height: 0.7">
        {{ currentNotification.title }}
      </p>
    </v-card-text>
    <label>نص الإشعار:</label>
    <v-card-text class="white rounded-xl rounded-tr-0 text-right">
      <p class="lead m-0 text-justify" style="line-height: 1.5">
        {{ currentNotification.body }}
      </p>
    </v-card-text>
    <label>نص الرابط:</label>
    <v-card-text class="white rounded-xl rounded-tr-0 text-right">
      <p class="lead m-0 text-justify" style="line-height: 1.5">
        {{ currentNotification.buttonText }}
      </p>
    </v-card-text>
    <label>رابط الإشعار:</label>
    <v-card-text class="white rounded-xl rounded-tr-0 text-right">
      <p class="lead m-0 text-justify" style="line-height: 1.5">
        {{ currentNotification.buttonUrl }}
      </p>
    </v-card-text>
    </div>
      <v-card-actions class="pt-4 justify-content-center">
      <v-btn @click="onConfirmDelete()" class="rounded-xl rounded-tr-0 py-5 px-10">
        حذف
        <img src="/media/svg/table/delete.svg" alt="delete" class="pr-2"/>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapGetters } from 'vuex';
export default {
   props:{
        notiyId: String
   },
    computed:{
      ...mapGetters(["currentNotification","placeholder","domainHost"])
    },
   created(){
      this.$store.dispatch("fetchCurrentNotification" , this.notiyId);
   },
   methods: {
        onConfirmDelete(){
            Swal.fire({
                title: "هل انت متأكد من الحذف ؟",
                text: "مازال بإمكانك التراجع",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                cancelButtonText: "تراجع",
                confirmButtonText: "أجل متأكد"
            }).then(result => {
                if (result.isConfirmed) {
                    this.$store.dispatch("deleteNotification", this.currentNotification);
                }
            });
        }
   },
   watch: {
       notiyId(){
           this.$store.dispatch("fetchCurrentNotification" , this.notiyId);
       }
   }
}
</script>